import React from "react";
import { CircleAlertIcon } from "lucide-react";
import { painPoints } from "../data/beforeAfter";
import { SectionCTA } from "./SectionCTA";
export function FamiliarSection() {
  return <section className="bg-navy-900 px-4 py-16 text-white md:py-24" data-id="element-107" data-mp="1d8hxkmjqeao7">
      <div className="mx-auto max-w-3xl" data-id="element-108" data-mp="1d5lzmy7vvlzr">
        <h2 className="text-center font-serif text-[32px] font-extrabold leading-tight md:text-5xl" data-id="element-109" data-mp="188n7umbozr4q">
          Does this sound <em className="text-brand-cyan" data-id="element-110" data-mp="kk3zy7wk1gd6">familiar?</em>
        </h2>
        <p className="mt-4 text-center text-lg text-white/75" data-id="element-111" data-mp="gi8y92app0yv">If you've ever experienced even one of these situations, I created this system for you.</p>

        <ul className="mt-10 divide-y divide-white/10 border-y border-white/10" data-id="element-112" data-mp="uaf5fyvvzxm6">
          {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-5 text-[17px] leading-relaxed text-white/90" data-id="element-113" data-mp="1stazwae3dnx">
              <CircleAlertIcon className="mt-1 h-6 w-6 shrink-0 text-brand-cyan" aria-hidden="true" data-id="element-114" data-mp="3szdu8tu7dhae" />
              {point}
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-115" data-mp="1hjzdfd4n2jrr">
          <p className="text-lg text-white/75" data-id="element-116" data-mp="1mkmzdke0gaf4">And I don't think you need another massive collection of orthodontic theory.</p>
          <p className="mt-3 font-serif text-2xl font-extrabold md:text-3xl" data-id="element-117" data-mp="1rd7r8gdcwdg0">
            You need a better way to <span className="text-brand-cyan" data-id="element-118" data-mp="1wagdas1ml1mj">organize what you already know.</span>
          </p>
        </div>

        <SectionCTA label="Yes, I want to organize what I already know" tone="dark" data-id="element-119" data-mp="yp28fz5v4yit" />
      </div>
    </section>;
}